// SEO utility hook for updating page metadata
import { useEffect } from 'react';

export const useSEO = ({ 
  title, 
  description, 
  image, 
  url, 
  type = 'website',
  keywords 
}) => {
  useEffect(() => {
    // Update title
    if (title) {
      document.title = title;
    }

    // Update meta description
    if (description) {
      updateMetaTag('name', 'description', description);
    }

    // Update keywords
    if (keywords) {
      updateMetaTag('name', 'keywords', keywords);
    }

    // Update Open Graph tags
    if (title) {
      updateMetaTag('property', 'og:title', title);
    }
    if (description) {
      updateMetaTag('property', 'og:description', description);
    }
    if (image) {
      updateMetaTag('property', 'og:image', image);
    }
    if (url) {
      updateMetaTag('property', 'og:url', url);
    }
    if (type) {
      updateMetaTag('property', 'og:type', type);
    }

    // Update Twitter Card tags
    if (title) {
      updateMetaTag('property', 'twitter:title', title);
    }
    if (description) {
      updateMetaTag('property', 'twitter:description', description);
    }
    if (image) {
      updateMetaTag('property', 'twitter:image', image);
    }

    // Update canonical URL
    if (url) {
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
      }
      canonical.setAttribute('href', url);
    }

    // Cleanup - reset to defaults when component unmounts
    return () => {
      document.title = 'Magnolia Mold Co - Handcrafted Polymer Clay Earrings';
      updateMetaTag('property', 'og:url', 'https://magnoliamoldco.com/');
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) {
        canonical.setAttribute('href', 'https://magnoliamoldco.com/');
      }
    };
  }, [title, description, image, url, type, keywords]);
};

// Helper function to update or create meta tags
const updateMetaTag = (attribute, key, content) => {
  let element = document.querySelector(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
};

export default useSEO;
